// @ts-nocheck

/* eslint-disable sonarjs/no-duplicate-string */
export default {
  FR: {
    1: [
      'Ça va trembler papa !',
      'Vas-y mon petit !',
      'Cours, Forrest, cours !',
      "La vache, j'ai chaud…",
      'Tout près du bonheur',
      'Bon, ça devrait passer…',
      'Pas de mauvaise surprise hein !',
      "C'est carré !",
      'Tout pour la daronne',
      'Alors peut-être ?',
      'Accélère, accélère !',
      "Vas-y Francky, c'est bon !",
    ],
    2: [
      'Ça va trembler papa !',
      'Vas-y mon petit !',
      'Cours, Forrest, cours !',
      "La vache, j'ai chaud…",
      'Tout près du bonheur',
      "C'est carré !",
      'Tout pour la daronne',
      'Alors peut-être ?',
      'Accélère, accélère !',
      "Vas-y Francky, c'est bon !",
    ],
    3: [
      'Ça va trembler papa !',
      'Vas-y mon petit !',
      'Cours, Forrest, cours !',
      "La vache, j'ai chaud…",
      'Tout près du bonheur',
      'Mise historique !',
      "C'est carré !",
      'Tout pour la daronne',
      'Alors peut-être ?',
      'Accélère, accélère !',
      "Vas-y Francky, c'est bon !",
    ],
    4: [
      'Ça va trembler papa !',
      'Vas-y mon petit !',
      'Oh oui viens, t’y es presque',
      'Combiné cousu main',
      'One, two, three… vive mon combi !',
      "La vache, j'ai chaud…",
      "Jusqu'ici tout va bien",
      'Tout près du bonheur',
      'Bon, ça devrait passer…',
      'Pas de mauvaise surprise hein !',
      "C'est carré !",
      'Tout pour la daronne',
      'Alors peut-être ?',
      'Accélère, accélère !',
      "Vas-y Francky, c'est bon !",
    ],
    5: [
      'Ça va trembler papa !',
      'Vas-y mon petit !',
      'Oh oui viens, t’y es presque',
      'Combiné cousu main',
      'One, two, three… vive mon combi !',
      "La vache, j'ai chaud…",
      "Jusqu'ici tout va bien",
      'Tout près du bonheur',
      "C'est carré !",
      'Tout pour la daronne',
      'Alors peut-être ?',
      'Accélère, accélère !',
      "Vas-y Francky, c'est bon !",
    ],
    6: [
      'Ça va trembler papa !',
      'Vas-y mon petit !',
      'Oh oui viens, t’y es presque',
      'Combiné cousu main',
      'One, two, three… vive mon combi !',
      "La vache, j'ai chaud…",
      "Jusqu'ici tout va bien",
      'Tout près du bonheur',
      'Mise historique !',
      "C'est carré !",
      'Tout pour la daronne',
      'Alors peut-être ?',
      'Accélère, accélère !',
      "Vas-y Francky, c'est bon !",
    ],
    7: [
      'Ça va trembler papa !',
      'Vas-y mon petit !',
      'Oh oui viens, t’y es presque',
      "La vache, j'ai chaud…",
      "Jusqu'ici tout va bien",
      'Tout près du bonheur',
      "C'est carré !",
      'Tout pour la daronne',
      'Alors peut-être ?',
      'Accélère, accélère !',
      "Vas-y Francky, c'est bon !",
    ],
    8: [
      'Ça va trembler papa !',
      'Vas-y mon petit !',
      'Oh oui viens, t’y es presque',
      "La vache, j'ai chaud…",
      "Jusqu'ici tout va bien",
      'Tout près du bonheur',
      "C'est carré !",
      'Tout pour la daronne',
      'Alors peut-être ?',
      'Accélère, accélère !',
      "Vas-y Francky, c'est bon !",
    ],
    9: [
      'Bang, bang, bang !',
      'Easy money ',
      'OKLM',
      'Et mercééééé',
      'Et ça fait BIM BAM BOUM',
      'C’est rentré selon la VAR',
      'Poteau rentrant !',
      'Sah, quel plaisir ! ',
      "Quelle vie d'artiste !",
      'Directement dans mes veines',
      "C'était facile",
      'Tu me parles pas de paris perdants !',
      'Mon instinct ne me trompe jamais...',
      "J'ai parié, j'ai vibré, j'ai encaissé !",
      'Pleine lulu !',
      'Injouable dans le money time !',
      'Même Kanté récupère moins que toi',
      "La VAR est formelle : t'es un crack",
    ],
    10: [
      'Bang, bang, bang !',
      'Une villa pour la mamma',
      'Easy money ',
      'Très tchatcheur !',
      'OKLM',
      'Et mercééééé',
      'Et ça fait BIM BAM BOUM',
      'La daronne à l’abri !',
      'C’est rentré selon la VAR',
      'Poteau rentrant !',
      'Sah, quel plaisir ! ',
      'Directement dans mes veines',
      'Gros respect !',
      "Quelle vie d'artiste !",
      'Gain historique !',
      'Tu me parles pas de paris perdants !',
      'Mon instinct ne me trompe jamais...',
      "J'ai parié, j'ai vibré, j'ai encaissé !",
      'Pleine lulu !',
      'Injouable dans le money time !',
      'Même Kanté récupère moins que toi',
      "La VAR est formelle : t'es un crack",
    ],
    11: [
      'Bang, bang, bang !',
      'Une villa pour la mamma',
      'Très tchatcheur !',
      'OKLM',
      'Et mercééééé',
      'La chatte à Dédé',
      'Et ça fait BIM BAM BOUM',
      'La daronne à l’abri !',
      'C’est rentré selon la VAR',
      'Poteau rentrant !',
      'Sah, quel plaisir ! ',
      'Gros respect !',
      "Quelle vie d'artiste !",
      'Gain historique !',
      'Tu me parles pas de paris perdants !',
      'Mon instinct ne me trompe jamais...',
      "J'ai parié, j'ai vibré, j'ai encaissé !",
      'Pleine lulu !',
      'Injouable dans le money time !',
      'Même Kanté récupère moins que toi',
      "La VAR est formelle : t'es un crack",
    ],
    12: [
      'Bang, bang, bang !',
      'Easy money ',
      'OKLM',
      'Combiné cousu main',
      'Et mercééééé',
      'La chatte à Dédé',
      'Et ça fait BIM BAM BOUM',
      'C’est rentré selon la VAR !',
      'C’est rentré selon la VAR',
      'Poteau rentrant !',
      'Sah, quel plaisir ! ',
      'Directement dans mes veines',
      'One, two, three… vive mon combi !',
      "Quelle vie d'artiste !",
      "C'était facile",
      'Tu me parles pas de paris perdants !',
      'Mon instinct ne me trompe jamais...',
      "J'ai parié, j'ai vibré, j'ai encaissé !",
      'Pleine lulu !',
      'Injouable dans le money time !',
      'Même Kanté récupère moins que toi',
      "La VAR est formelle : t'es un crack",
    ],
    13: [
      'Bang, bang, bang !',
      'Une villa pour la mamma',
      'Easy money ',
      'Très tchatcheur !',
      'OKLM',
      'Combiné cousu main',
      'Et mercééééé',
      'Et ça fait BIM BAM BOUM',
      'La daronne à l’abri !',
      'C’est rentré selon la VAR',
      'Poteau rentrant !',
      'Sah, quel plaisir ! ',
      'Directement dans mes veines',
      'Gros respect !',
      'One, two, three… vive mon combi !',
      "Quelle vie d'artiste !",
      'Gain historique !',
      'La chatte à Dédé',
      'Tu me parles pas de paris perdants !',
      'Mon instinct ne me trompe jamais...',
      "J'ai parié, j'ai vibré, j'ai encaissé !",
      'Pleine lulu !',
      'Injouable dans le money time !',
      'Même Kanté récupère moins que toi',
      "La VAR est formelle : t'es un crack",
    ],
    14: [
      'Bang, bang, bang !',
      'Une villa pour la mamma',
      'Très tchatcheur !',
      'OKLM',
      'Combiné cousu main',
      'Et mercééééé',
      'La chatte à Dédé',
      'Et ça fait BIM BAM BOUM',
      'La daronne à l’abri !',
      'C’est rentré selon la VAR',
      'Poteau rentrant !',
      'Sah, quel plaisir ! ',
      'Gros respect !',
      'One, two, three… vive mon combi !',
      "Quelle vie d'artiste !",
      'Gain historique !',
      'Tu me parles pas de paris perdants !',
      'Mon instinct ne me trompe jamais...',
      "J'ai parié, j'ai vibré, j'ai encaissé !",
      'Pleine lulu !',
      'Injouable dans le money time !',
      'Même Kanté récupère moins que toi',
      "La VAR est formelle : t'es un crack",
    ],
    15: [
      'Bang, bang, bang !',
      'Easy money ',
      'Très tchatcheur !',
      'OKLM',
      'Et mercééééé',
      'La chatte à Dédé',
      'Et ça fait BIM BAM BOUM',
      'La daronne à l’abri !',
      'C’est rentré selon la VAR',
      'Poteau rentrant !',
      'Sah, quel plaisir ! ',
      'Directement dans mes veines',
      'Gros respect !',
      "Quelle vie d'artiste !",
      'Gain historique !',
      'Tu me parles pas de paris perdants !',
      'Mon instinct ne me trompe jamais...',
      "J'ai parié, j'ai vibré, j'ai encaissé !",
      'Pleine lulu !',
      'Injouable dans le money time !',
      'Même Kanté récupère moins que toi',
      "La VAR est formelle : t'es un crack",
    ],
    16: [
      'Bang, bang, bang !',
      'Easy money ',
      'Très tchatcheur !',
      'OKLM',
      'Et mercééééé',
      'La chatte à Dédé',
      'Et ça fait BIM BAM BOUM',
      'La daronne à l’abri !',
      'C’est rentré selon la VAR',
      'Poteau rentrant !',
      'Sah, quel plaisir ! ',
      'Directement dans mes veines',
      'Gros respect !',
      "Quelle vie d'artiste !",
      'Gain historique !',
      'Tu me parles pas de paris perdants !',
      'Mon instinct ne me trompe jamais...',
      "J'ai parié, j'ai vibré, j'ai encaissé !",
      'Pleine lulu !',
      'Injouable dans le money time !',
      'Même Kanté récupère moins que toi',
      "La VAR est formelle : t'es un crack",
    ],
    17: [
      'Bang, bang, bang !',
      'Une villa pour la mamma',
      'Très tchatcheur !',
      'OKLM',
      'Et mercééééé',
      'La chatte à Dédé',
      'Et ça fait BIM BAM BOUM',
      'La daronne à l’abri !',
      'C’est rentré selon la VAR',
      'Poteau rentrant !',
      'Sah, quel plaisir ! ',
      'Gros respect !',
      "Quelle vie d'artiste !",
      'Gain historique !',
      'Tu me parles pas de paris perdants !',
      'Mon instinct ne me trompe jamais...',
      "J'ai parié, j'ai vibré, j'ai encaissé !",
      'Pleine lulu !',
      'Injouable dans le money time !',
      'Même Kanté récupère moins que toi',
      "La VAR est formelle : t'es un crack",
    ],
    18: [
      'Les prooooblèmes !',
      'T’es nul ! Nul !',
      'Claqué au sol',
      "L'histoire de ma vie…",
      'Demain est un autre jour !',
      'Allez… NEXT',
      'Bon, je vais me mettre au poker',
      'VAR DECISION : NO GAIN',
      "J'ai raté la bascule…",
    ],
    19: [
      'Les prooooblèmes !',
      'T’es nul ! Nul !',
      'Claqué au sol',
      "L'histoire de ma vie…",
      'Demain est un autre jour !',
      'Allez… NEXT',
      'Bon, je vais me mettre au poker',
      'VAR DECISION : NO GAIN',
      'Si près, si loin',
      "Dommage, j'avais la cote",
      "J'ai raté la bascule…",
    ],
    20: [
      'Les prooooblèmes !',
      'T’es nul ! Nul !',
      'Claqué au sol',
      "L'histoire de ma vie…",
      'Demain est un autre jour !',
      'Allez… NEXT',
      'Bon, je vais me mettre au poker',
      "J'ai raté la bascule…",
    ],
    21: [
      'Les prooooblèmes !',
      "L'histoire de ma vie…",
      'Demain est un autre jour !',
      'VAR DECISION : NO GAIN',
      'Si près, si loin',
      "Dommage, j'avais la cote",
      "J'ai raté la bascule…",
    ],
    22: [
      'Les prooooblèmes !',
      'T’es nul ! Nul !',
      'Claqué au sol',
      "L'histoire de ma vie…",
      'Demain est un autre jour !',
      'Allez… NEXT',
      'Bon, je vais me mettre au poker',
      'VAR DECISION : NO GAIN',
      'Si près, si loin',
      "Dommage, j'avais la cote",
      "J'ai raté la bascule…",
    ],
    23: [
      'Les prooooblèmes !',
      'T’es nul ! Nul !',
      'Claqué au sol',
      "L'histoire de ma vie…",
      'Demain est un autre jour !',
      'Allez… NEXT',
      'Bon, je vais me mettre au poker',
      'VAR DECISION : NO GAIN',
      'Si près, si loin',
      "Dommage, j'avais la cote",
      "J'ai raté la bascule…",
    ],
    24: [
      'Les prooooblèmes !',
      'T’es nul ! Nul !',
      'Claqué au sol',
      "L'histoire de ma vie…",
      'Demain est un autre jour !',
      'Allez… NEXT',
      'Bon, je vais me mettre au poker',
      'VAR DECISION : NO GAIN',
      'Si près, si loin',
      "Dommage, j'avais la cote",
      "J'ai raté la bascule…",
    ],
    25: [
      'Remplacement !',
      'Tu t’es retiré à temps',
      'Sors, sors, sors !',
      "Bon, c'est déjà ça…",
      'Toujours ça de pris !',
    ],
    26: [
      'Bang, bang, bang !',
      'Une villa pour la mamma',
      'Très tchatcheur !',
      'OKLM',
      'Et mercééééé',
      'La chatte à Dédé',
      'Et ça fait BIM BAM BOUM',
      'La daronne à l’abri !',
      'C’est rentré selon la VAR',
      'Poteau rentrant !',
      'Sah, quel plaisir ! ',
      'Gros respect !',
      "Quelle vie d'artiste !",
      'Gain historique !',
      "J'avais tout prévu",
      'Voyant de père en fils !',
    ],
    27: ['Remplacement !', 'Tu t’es retiré à temps', 'Sors, sors, sors !', "J'avais tout prévu"],
    28: [],
  },
  EN: {
    1: ['Almost there!', 'Fingers crossed…', 'So far, so good!', 'On the road to a golden ticket', 'And now, we wait…'],
    2: ['Almost there!', 'Fingers crossed…', 'So far, so good!', 'On the road to a golden ticket', 'And now, we wait…'],
    3: ['Almost there!', 'Fingers crossed…', 'So far, so good!', 'On the road to a golden ticket', 'And now, we wait…'],
    4: ['Almost there!', 'Fingers crossed…', 'So far, so good!', 'On the road to a golden ticket', 'And now, we wait…'],
    5: ['Almost there!', 'Fingers crossed…', 'So far, so good!', 'On the road to a golden ticket', 'And now, we wait…'],
    6: ['Almost there!', 'Fingers crossed…', 'So far, so good!', 'On the road to a golden ticket', 'And now, we wait…'],
    7: ['Almost there!', 'Fingers crossed…', 'So far, so good!', 'On the road to a golden ticket', 'And now, we wait…'],
    8: ['Almost there!', 'Fingers crossed…', 'So far, so good!', 'On the road to a golden ticket', 'And now, we wait…'],
    9: ['Easy money', 'Sick run', 'Bang bang bang!', 'Get in there!', 'Winner Winner chicken dinner!'],
    10: ['Easy money', 'Sick run', 'Bang bang bang!', 'Get in there!', 'Winner Winner chicken dinner!'],
    11: ['Easy money', 'Sick run', 'Bang bang bang!', 'Get in there!', 'Winner Winner chicken dinner!'],
    12: ['Easy money', 'Sick run', 'Bang bang bang!', 'Get in there!', 'Winner Winner chicken dinner!'],
    13: ['Easy money', 'Sick run', 'Bang bang bang!', 'Get in there!', 'Winner Winner chicken dinner!'],
    14: ['Easy money', 'Sick run', 'Bang bang bang!', 'Get in there!', 'Winner Winner chicken dinner!'],
    15: ['Easy money', 'Sick run', 'Bang bang bang!', 'Get in there!', 'Winner Winner chicken dinner!'],
    16: ['Easy money', 'Sick run', 'Bang bang bang!', 'Get in there!', 'Winner Winner chicken dinner!'],
    17: ['Easy money', 'Sick run', 'Bang bang bang!', 'Get in there!', 'Winner Winner chicken dinner!'],
    18: [
      'Story of my life…',
      'Looks like I need to switch to poker',
      'Too bad... but the odds were worth it!',
      'So close and yet so far',
      'Ouch! Unlucky…',
    ],
    19: [
      'Story of my life…',
      'Looks like I need to switch to poker',
      'Too bad... but the odds were worth it!',
      'So close and yet so far',
      'Ouch! Unlucky…',
    ],
    20: [
      'Story of my life…',
      'Looks like I need to switch to poker',
      'Too bad... but the odds were worth it!',
      'So close and yet so far',
      'Ouch! Unlucky…',
    ],
    21: [
      'Story of my life…',
      'Looks like I need to switch to poker',
      'Too bad... but the odds were worth it!',
      'So close and yet so far',
      'Ouch! Unlucky…',
    ],
    22: [
      'Story of my life…',
      'Looks like I need to switch to poker',
      'Too bad... but the odds were worth it!',
      'So close and yet so far',
      'Ouch! Unlucky…',
    ],
    23: [
      'Story of my life…',
      'Looks like I need to switch to poker',
      'Too bad... but the odds were worth it!',
      'So close and yet so far',
      'Ouch! Unlucky…',
    ],
    24: [
      'Story of my life…',
      'Looks like I need to switch to poker',
      'Too bad... but the odds were worth it!',
      'So close and yet so far',
      'Ouch! Unlucky…',
    ],
    25: [
      'Ref, sub please!',
      'You withdrew just in time',
      'Go, go, go!',
      'Get out! Get ouuuuuut!',
      "Get out whilst you're ahead",
    ],
    26: [
      'Ref, sub please!',
      'You withdrew just in time',
      'Go, go, go!',
      'Get out! Get ouuuuuut!',
      "Get out whilst you're ahead",
    ],
    27: [
      'Ref, sub please!',
      'You withdrew just in time',
      'Go, go, go!',
      'Get out! Get ouuuuuut!',
      "Get out whilst you're ahead",
    ],
    28: [],
  },
  DE: {
    1: ['Komm schon! ', 'Fast geschafft!', 'Bis hierhin ist alles gut!', 'Lauf, Forrest, lauf!', 'Es bleibt spannend…'],
    2: ['Komm schon! ', 'Fast geschafft!', 'Bis hierhin ist alles gut!', 'Lauf, Forrest, lauf!', 'Es bleibt spannend…'],
    3: ['Komm schon! ', 'Fast geschafft!', 'Bis hierhin ist alles gut!', 'Lauf, Forrest, lauf!', 'Es bleibt spannend…'],
    4: ['Komm schon! ', 'Fast geschafft!', 'Bis hierhin ist alles gut!', 'Lauf, Forrest, lauf!', 'Es bleibt spannend…'],
    5: ['Komm schon! ', 'Fast geschafft!', 'Bis hierhin ist alles gut!', 'Lauf, Forrest, lauf!', 'Es bleibt spannend…'],
    6: ['Komm schon! ', 'Fast geschafft!', 'Bis hierhin ist alles gut!', 'Lauf, Forrest, lauf!', 'Es bleibt spannend…'],
    7: ['Komm schon! ', 'Fast geschafft!', 'Bis hierhin ist alles gut!', 'Lauf, Forrest, lauf!', 'Es bleibt spannend…'],
    8: ['Komm schon! ', 'Fast geschafft!', 'Bis hierhin ist alles gut!', 'Lauf, Forrest, lauf!', 'Es bleibt spannend…'],
    9: [
      'Bang, bang, bang!',
      'Easy money!',
      "Warum hab' ich nicht mehr gesetzt?",
      "So wird's gemacht!",
      'Ein historischer Gewinn!',
    ],
    10: [
      'Bang, bang, bang!',
      'Easy money!',
      "Warum hab' ich nicht mehr gesetzt?",
      "So wird's gemacht!",
      'Ein historischer Gewinn!',
    ],
    11: [
      'Bang, bang, bang!',
      'Easy money!',
      "Warum hab' ich nicht mehr gesetzt?",
      "So wird's gemacht!",
      'Ein historischer Gewinn!',
    ],
    12: [
      'Bang, bang, bang!',
      'Easy money!',
      "Warum hab' ich nicht mehr gesetzt?",
      "So wird's gemacht!",
      'Ein historischer Gewinn!',
    ],
    13: [
      'Bang, bang, bang!',
      'Easy money!',
      "Warum hab' ich nicht mehr gesetzt?",
      "So wird's gemacht!",
      'Ein historischer Gewinn!',
    ],
    14: [
      'Bang, bang, bang!',
      'Easy money!',
      "Warum hab' ich nicht mehr gesetzt?",
      "So wird's gemacht!",
      'Ein historischer Gewinn!',
    ],
    15: [
      'Bang, bang, bang!',
      'Easy money!',
      "Warum hab' ich nicht mehr gesetzt?",
      "So wird's gemacht!",
      'Ein historischer Gewinn!',
    ],
    16: [
      'Bang, bang, bang!',
      'Easy money!',
      "Warum hab' ich nicht mehr gesetzt?",
      "So wird's gemacht!",
      'Ein historischer Gewinn!',
    ],
    17: [
      'Bang, bang, bang!',
      'Easy money!',
      "Warum hab' ich nicht mehr gesetzt?",
      "So wird's gemacht!",
      'Ein historischer Gewinn!',
    ],
    18: [
      'Schade, aber die Quote war es wert!',
      'Morgen ist ein anderer Tag!',
      'VIDEOBEWEIS: KEIN GEWINN',
      'Naja… NEXT',
      'So nah und doch so fern…',
    ],
    19: [
      'Schade, aber die Quote war es wert!',
      'Morgen ist ein anderer Tag!',
      'VIDEOBEWEIS: KEIN GEWINN',
      'Naja… NEXT',
      'So nah und doch so fern…',
    ],
    20: [
      'Schade, aber die Quote war es wert!',
      'Morgen ist ein anderer Tag!',
      'VIDEOBEWEIS: KEIN GEWINN',
      'Naja… NEXT',
      'So nah und doch so fern…',
    ],
    21: [
      'Schade, aber die Quote war es wert!',
      'Morgen ist ein anderer Tag!',
      'VIDEOBEWEIS: KEIN GEWINN',
      'Naja… NEXT',
      'So nah und doch so fern…',
    ],
    22: [
      'Schade, aber die Quote war es wert!',
      'Morgen ist ein anderer Tag!',
      'VIDEOBEWEIS: KEIN GEWINN',
      'Naja… NEXT',
      'So nah und doch so fern…',
    ],
    23: [
      'Schade, aber die Quote war es wert!',
      'Morgen ist ein anderer Tag!',
      'VIDEOBEWEIS: KEIN GEWINN',
      'Naja… NEXT',
      'So nah und doch so fern…',
    ],
    24: [
      'Schade, aber die Quote war es wert!',
      'Morgen ist ein anderer Tag!',
      'VIDEOBEWEIS: KEIN GEWINN',
      'Naja… NEXT',
      'So nah und doch so fern…',
    ],
    25: ['Schiri, Auswechslung bitte!', 'Aufhören, wenn es am schönsten ist.', 'Raus, raus, raus!'],
    26: ['Schiri, Auswechslung bitte!', 'Aufhören, wenn es am schönsten ist.', 'Raus, raus, raus!'],
    27: ['Schiri, Auswechslung bitte!', 'Aufhören, wenn es am schönsten ist.', 'Raus, raus, raus!'],
    28: [],
  },
  ES: {
    1: [
      'Ya está casi',
      'Cruzando los dedos',
      'De momento, todo va bien',
      'El bollo está en el horno',
      'Estamos cerca',
      'Señor, dame paciencia',
      'Prepara la bolsa de pipas…',
      'Kitt, te necesito',
      'Solo queda rezar',
      '¡A por el bote, oé!',
      'Me está estresando',
      'Estoy como un flan',
      'Abróchense el cinturón',
      'Un poco más cerca de la jubilación',
      'Venga, que ya casi está ',
    ],
    2: [
      'Ya está casi',
      'Cruzando los dedos',
      'De momento, todo va bien',
      'El bollo está en el horno',
      'Estamos cerca',
      'Señor, dame paciencia',
      'Prepara la bolsa de pipas…',
      'Kitt, te necesito',
      'Solo queda rezar',
      '¡A por el bote, oé!',
      'Me está estresando',
      'Estoy como un flan',
      'Abróchense el cinturón',
      'Un poco más cerca de la jubilación',
      'Venga, que ya casi está ',
    ],
    3: [
      'Ya está casi',
      'Cruzando los dedos',
      'De momento, todo va bien',
      'El bollo está en el horno',
      'Estamos cerca',
      'Señor, dame paciencia',
      'Prepara la bolsa de pipas…',
      'Kitt, te necesito',
      'Solo queda rezar',
      '¡A por el bote, oé!',
      'Partido a partido',
      'Me está estresando',
      'Estoy como un flan',
      'Abróchense el cinturón',
      'Un poco más cerca de la jubilación',
      'Venga, que ya casi está ',
    ],
    4: [
      'Ya está casi',
      'Cruzando los dedos',
      'De momento, todo va bien',
      'El bollo está en el horno',
      'Estamos cerca',
      'Señor, dame paciencia',
      'Prepara la bolsa de pipas…',
      'Kitt, te necesito',
      'Solo queda rezar',
      '¡A por el bote, oé!',
      'Partido a partido',
      'Me está estresando',
      'Estoy como un flan',
      'Abróchense el cinturón',
      'Un poco más cerca de la jubilación',
      'Venga, que ya casi está ',
    ],
    5: [
      'Ya está casi',
      'Cruzando los dedos',
      'De momento, todo va bien',
      'El bollo está en el horno',
      'Estamos cerca',
      'Señor, dame paciencia',
      'Prepara la bolsa de pipas…',
      'Kitt, te necesito',
      'Solo queda rezar',
      '¡A por el bote, oé!',
      'Partido a partido',
      'Me está estresando',
      'Estoy como un flan',
      'Abróchense el cinturón',
      'Un poco más cerca de la jubilación',
      'Venga, que ya casi está ',
    ],
    6: [
      'Ya está casi',
      'Cruzando los dedos',
      'De momento, todo va bien',
      'El bollo está en el horno',
      'Estamos cerca',
      'Señor, dame paciencia',
      'Prepara la bolsa de pipas…',
      'Kitt, te necesito',
      'Solo queda rezar',
      '¡A por el bote, oé!',
      'Partido a partido',
      'Me está estresando',
      'Estoy como un flan',
      'Abróchense el cinturón',
      'Un poco más cerca de la jubilación',
      'Venga, que ya casi está ',
    ],
    7: [
      'Ya está casi',
      'Cruzando los dedos',
      'De momento, todo va bien',
      'El bollo está en el horno',
      'Estamos cerca',
      'Señor, dame paciencia',
      'Prepara la bolsa de pipas…',
      'Kitt, te necesito',
      'Solo queda rezar',
      '¡A por el bote, oé!',
      'Partido a partido',
      'Me está estresando',
      'Estoy como un flan',
      'Abróchense el cinturón',
      'Un poco más cerca de la jubilación',
      'Venga, que ya casi está ',
    ],
    8: [
      'Ya está casi',
      'Cruzando los dedos',
      'De momento, todo va bien',
      'El bollo está en el horno',
      'Estamos cerca',
      'Señor, dame paciencia',
      'Prepara la bolsa de pipas…',
      'Kitt, te necesito',
      'Solo queda rezar',
      '¡A por el bote, oé!',
      'Partido a partido',
      'Me está estresando',
      'Estoy como un flan',
      'Abróchense el cinturón',
      'Un poco más cerca de la jubilación',
      'Venga, que ya casi está ',
    ],
    9: [
      'Directo al bolsillo',
      '¡Toma, toma, toma!',
      'Ha valido la pena',
      'Tengo pasta, ¡hoy se sale!',
      'Ven con papá',
      '¡Dale calooooor!',
      '¡A ganar, a ganar, pollo para cenar!',
      'Ahora vas y lo cascas',
      '¡Pim pam, toma lacasitos!',
      '¡Sí se puede!',
      '¡Me encanta que los planes salgan bien!',
      'Más flor que Zizou',
      '¡Pero qué ha pachado!',
      '¡Todo ha salido a pedir de Milhouse!',
      '¡Pasta gansa!',
      'Vamosssss',
      'Siri, búscame un vuelo a Punta Cana',
      'Mi banquero se alegrará con esto',
      'Creo que debería hacerme tipster',
      'El VAR ha revisado tu apuesta y… ¡es ganadora!',
      'Otra apuesta ganadora.  No serás Maldini, ¿no?',
      'Una apuesta de categoría. ¿Eh, Moro?',
      'Mi instinto nunca me traiciona.',
      'Estoy en mi peak',
    ],
    10: [
      'Dinero fácil',
      'Directo al bolsillo',
      '¡Toma, toma, toma!',
      'Ha valido la pena',
      'Tengo pasta, ¡hoy se sale!',
      'Ven con papá',
      '¡Dale calooooor!',
      '¡A ganar, a ganar, pollo para cenar!',
      'Ahora vas y lo cascas',
      '¡Pim pam, toma lacasitos!',
      'Sì se puede!',
      '¡Me encanta que los planes salgan bien!',
      'Más flor que Zizou',
      '¡Pero qué ha pachado!',
      '¡Todo ha salido a pedir de Milhouse!',
      '¡Pasta gansa!',
      'Vamosssss',
      'Siri, búscame un vuelo a Punta Cana',
      'Mi banquero se alegrará con esto',
      'Creo que debería hacerme tipster',
      'El VAR ha revisado tu apuesta y… ¡es ganadora!',
      'Otra apuesta ganadora.  No serás Maldini, ¿no?',
      'Una apuesta de categoría. ¿Eh, Moro?',
      'Mi instinto nunca me traiciona.',
      'Estoy en mi peak',
    ],
    11: [
      'Directo al bolsillo',
      'Toma, toma, toma!',
      'Ha valido la pena',
      'Tengo pasta, ¡hoy se sale!',
      'Ven con papá',
      '¡Dale calooooor!',
      '¡A ganar, a ganar, pollo para cenar!',
      'Ahora vas y lo cascas',
      'Pim Pam, toma lacasitos!',
      'Sì se puede!',
      '¡Me encanta que los planes salgan bien!',
      'Más flor que Zizou',
      '¡Pero qué ha pachado!',
      '¡Todo ha salido a pedir de Milhouse!',
      '¡Pasta gansa!',
      'Vamosssss',
      'Siri, búscame un vuelo a Punta Cana',
      'Mi banquero se alegrará con esto',
      'Creo que debería hacerme tipster',
      'El VAR ha revisado tu apuesta y… ¡es ganadora!',
      'Otra apuesta ganadora.  No serás Maldini, ¿no?',
      'Una apuesta de categoría. ¿Eh, Moro?',
      'Mi instinto nunca me traiciona.',
      'Estoy en mi peak',
    ],
    12: [
      'Dinero fácil',
      'Directo al bolsillo',
      '¡Toma, toma, toma!',
      'Ha valido la pena',
      'Tengo pasta, ¡hoy se sale!',
      'Ven con papá',
      '¡Dale calooooor!',
      '¡A ganar, a ganar, pollo para cenar!',
      'Ahora vas y lo cascas',
      '¡Pim pam, toma lacasitos!',
      '¡Sí se puede!',
      '¡Me encanta que los planes salgan bien!',
      'Más flor que Zizou',
      '¡Pero qué ha pachado!',
      '¡Todo ha salido a pedir de Milhouse!',
      '¡Pasta gansa!',
      'Vamosssss',
      'Siri, búscame un vuelo a Punta Cana',
      'Mi banquero se alegrará con esto',
      'Creo que debería hacerme tipster',
      'El VAR ha revisado tu apuesta y… ¡es ganadora!',
      'Otra apuesta ganadora.  No serás Maldini, ¿no?',
      'Una apuesta de categoría. ¿Eh, Moro?',
      'Mi instinto nunca me traiciona.',
      'Estoy en mi peak',
    ],
    13: [
      'Directo al bolsillo',
      '¡Toma, toma, toma!',
      'Ha valido la pena',
      'Tengo pasta, ¡hoy se sale!',
      'Ven con papá',
      '¡Dale calooooor!',
      '¡A ganar, a ganar, pollo para cenar!',
      'Ahora vas y lo cascas',
      '¡Pim pam, toma lacasitos!',
      '¡Sí se puede!',
      '¡Me encanta que los planes salgan bien!',
      'Más flor que Zizou',
      '¡Pero qué ha pachado!',
      '¡Todo ha salido a pedir de Milhouse!',
      '¡Pasta gansa!',
      'Vamosssss',
      'Siri, búscame un vuelo a Punta Cana',
      'Mi banquero se alegrará con esto',
      'Creo que debería hacerme tipster',
      'El VAR ha revisado tu apuesta y… ¡es ganadora!',
      'Otra apuesta ganadora.  No serás Maldini, ¿no?',
      'Una apuesta de categoría. ¿Eh, Moro?',
      'Mi instinto nunca me traiciona.',
      'Estoy en mi peak',
    ],
    14: [
      'Directo al bolsillo',
      '¡Toma, toma, toma!',
      'Ha valido la pena',
      'Tengo pasta, ¡hoy se sale!',
      'Ven con papá',
      '¡Dale calooooor!',
      '¡A ganar, a ganar, pollo para cenar!',
      'Ahora vas y lo cascas',
      '¡Pim pam, toma lacasitos!',
      '¡Sí se puede!',
      '¡Me encanta que los planes salgan bien!',
      'Más flor que Zizou',
      '¡Pero qué ha pachado!',
      '¡Todo ha salido a pedir de Milhouse!',
      '¡Pasta gansa!',
      'Vamosssss',
      'Siri, búscame un vuelo a Punta Cana',
      'Mi banquero se alegrará con esto',
      'Creo que debería hacerme tipster',
      'El VAR ha revisado tu apuesta y… ¡es ganadora!',
      'Otra apuesta ganadora.  No serás Maldini, ¿no?',
      'Una apuesta de categoría. ¿Eh, Moro?',
      'Mi instinto nunca me traiciona.',
      'Estoy en mi peak',
    ],
    15: [
      'Directo al bolsillo',
      '¡Toma, toma, toma!',
      'Ha valido la pena',
      'Tengo pasta, ¡hoy se sale!',
      'Ven con papá',
      '¡Dale calooooor!',
      '¡A ganar, a ganar, pollo para cenar!',
      'Ahora vas y lo cascas',
      '¡Pim pam, toma lacasitos!',
      '¡Sí se puede!',
      '¡Me encanta que los planes salgan bien!',
      'Más flor que Zizou',
      '¡Pero qué ha pachado!',
      '¡Todo ha salido a pedir de Milhouse!',
      '¡Pasta gansa!',
      'Vamosssss',
      'Siri, búscame un vuelo a Punta Cana',
      'Mi banquero se alegrará con esto',
      'Creo que debería hacerme tipster',
      'El VAR ha revisado tu apuesta y… ¡es ganadora!',
      'Otra apuesta ganadora.  No serás Maldini, ¿no?',
      'Una apuesta de categoría. ¿Eh, Moro?',
      'Mi instinto nunca me traiciona.',
      'Estoy en mi peak',
    ],
    16: [
      'Dinero fácil',
      'Directo al bolsillo',
      '¡Toma, toma, toma!',
      'Ha valido la pena',
      'Tengo pasta, ¡hoy se sale!',
      'Ven con papá',
      '¡Dale calooooor!',
      '¡A ganar, a ganar, pollo para cenar!',
      'Ahora vas y lo cascas',
      '¡Pim pam, toma lacasitos!',
      '¡Sí se puede!',
      '¡Me encanta que los planes salgan bien!',
      'Más flor que Zizou',
      '¡Pero qué ha pachado!',
      '¡Todo ha salido a pedir de Milhouse!',
      '¡Pasta gansa!',
      'Vamosssss',
      'Siri, búscame un vuelo a Punta Cana',
      'Mi banquero se alegrará con esto',
      'Creo que debería hacerme tipster',
      'El VAR ha revisado tu apuesta y… ¡es ganadora!',
      'Otra apuesta ganadora.  No serás Maldini, ¿no?',
      'Una apuesta de categoría. ¿Eh, Moro?',
      'Mi instinto nunca me traiciona.',
      'Estoy en mi peak',
    ],
    17: [
      'Directo al bolsillo',
      '¡Toma, toma, toma!',
      'Ha valido la pena',
      'Tengo pasta, ¡hoy se sale!',
      'Ven con papá',
      '¡Dale calooooor!',
      '¡A ganar, a ganar, pollo para cenar!',
      'Ahora vas y lo cascas',
      '¡Pim pam, toma lacasitos!',
      '¡Sí se puede!',
      '¡Me encanta que los planes salgan bien!',
      'Más flor que Zizou',
      '¡Pero qué ha pachado!',
      '¡Todo ha salido a pedir de Milhouse!',
      '¡Pasta gansa!',
      'Vamosssss',
      'Siri, búscame un vuelo a Punta Cana',
      'Mi banquero se alegrará con esto',
      'Creo que debería hacerme tipster',
      'El VAR ha revisado tu apuesta y… ¡es ganadora!',
      'Otra apuesta ganadora.  No serás Maldini, ¿no?',
      'Una apuesta de categoría. ¿Eh, Moro?',
      'Mi instinto nunca me traiciona.',
      'Estoy en mi peak',
    ],
    18: [
      'La historia de mi vida…',
      'Tengo que pasarme al póker',
      'Casi casi',
      'Vaya, ¡qué mala suerte!',
      'Venga, siguiente…',
      'Estaba difícil la cosa',
      'Mañana será otro día',
      'Perdimos porque no ganamos',
      'Hasta luego, Lucas',
      'Esto es todo, amigos',
      'Chanquete ha muerto',
      'Si lo sé, no vengo',
      '¡La noche me confunde!',
      'Al menos tengo suerte en el amor',
      '¿Por qué siempre igual?',
      'Más vale reír que llorar',
      'Definitivamente, me cambio de equipo',
      'Lo mío es el parchís',
    ],
    19: [
      'La historia de mi vida…',
      'Tengo que pasarme al póker',
      'Casi casi',
      'Vaya, ¡qué mala suerte!',
      'Venga, siguiente…',
      'Estaba difícil la cosa',
      'Mañana será otro día',
      'Perdimos porque no ganamos',
      'Hasta luego, Lucas',
      'Esto es todo, amigos',
      'Chanquete ha muerto',
      'Si lo sé, no vengo',
      '¡La noche me confunde!',
      'Al menos tengo suerte en el amor',
      'Más vale reír que llorar',
      'Definitivamente, me cambio de equipo',
      'Lo mío es el parchís',
    ],
    20: [
      'La historia de mi vida…',
      'Tengo que pasarme al póker',
      'Casi casi',
      'Vaya, ¡qué mala suerte!',
      'Venga, siguiente…',
      'Estaba difícil la cosa',
      'Mañana será otro día',
      'Perdimos porque no ganamos',
      'Hasta luego, Lucas',
      'Esto es todo, amigos',
      'Chanquete ha muerto',
      'Si lo sé, no vengo',
      '¡La noche me confunde!',
      'Al menos tengo suerte en el amor',
      'Más vale reír que llorar',
      'Definitivamente, me cambio de equipo',
      'Lo mío es el parchís',
    ],
    21: [
      'La historia de mi vida…',
      'Tengo que pasarme al póker',
      'Casi casi',
      'Vaya, ¡qué mala suerte!',
      'Venga, siguiente…',
      'Estaba difícil la cosa',
      'Mañana será otro día',
      'Perdimos porque no ganamos',
      'Hasta luego, Lucas',
      'Esto es todo, amigos',
      'Chanquete ha muerto',
      'Si lo sé, no vengo',
      '¡La noche me confunde!',
      'Al menos tengo suerte en el amor',
      'Más vale reír que llorar',
      'Definitivamente, me cambio de equipo',
      'Lo mío es el parchís',
    ],
    22: [
      'La historia de mi vida…',
      'Tengo que pasarme al póker',
      'Casi casi',
      'Vaya, ¡qué mala suerte!',
      'Venga, siguiente…',
      'Estaba difícil la cosa',
      'Mañana será otro día',
      'Perdimos porque no ganamos',
      'Hasta luego, Lucas',
      'Esto es todo, amigos',
      'Chanquete ha muerto',
      'Si lo sé, no vengo',
      '¡La noche me confunde!',
      'Al menos tengo suerte en el amor',
      'Más vale reír que llorar',
      'Definitivamente, me cambio de equipo',
      'Lo mío es el parchís',
    ],
    23: [
      'La historia de mi vida…',
      'Tengo que pasarme al póker',
      'Casi casi',
      'Vaya, ¡qué mala suerte!',
      'Venga, siguiente…',
      'Estaba difícil la cosa',
      'Mañana será otro día',
      'Perdimos porque no ganamos',
      'Hasta luego, Lucas',
      'Esto es todo, amigos',
      'Chanquete ha muerto',
      'Si lo sé, no vengo',
      '¡La noche me confunde!',
      'Al menos tengo suerte en el amor',
      'Más vale reír que llorar',
      'Definitivamente, me cambio de equipo',
      'Lo mío es el parchís',
    ],
    24: [
      'La historia de mi vida…',
      'Tengo que pasarme al póker',
      'Casi casi',
      'Vaya, ¡qué mala suerte!',
      'Venga, siguiente…',
      'Estaba difícil la cosa',
      'Mañana será otro día',
      'Perdimos porque no ganamos',
      'Hasta luego, Lucas',
      'Esto es todo, amigos',
      'Chanquete ha muerto',
      'Si lo sé, no vengo',
      '¡La noche me confunde!',
      'Al menos tengo suerte en el amor',
      'Más vale reír que llorar',
      'Definitivamente, me cambio de equipo',
      'Lo mío es el parchís',
    ],
    25: [
      'Más vale pájaro en mano…',
      'Una retirada a tiempo',
      'Al menos, esto que me llevo',
      'Ven con papá',
      'Esto es todo, amigos',
      'Estaba difícil la cosa',
    ],
    26: [
      '¡Todo estaba previsto!',
      'Una retirada a tiempo…',
      'Directo al bolsillo',
      '¡Toma, toma, toma!',
      'Ven con papá',
      '¡Sí se puede!',
      '¡Me encanta que los planes salgan bien!',
      'Vamosssss',
    ],
    27: [
      'Más vale pájaro en mano…',
      'Una retirada a tiempo…',
      '¡Todo estaba previsto!',
      'Directo al bolsillo',
      '¡Toma, toma, toma!',
      'Ven con papá',
      '¡Sí se puede!',
      '¡Me encanta que los planes salgan bien!',
      'Vamosssss',
    ],
    28: [],
  },
  IT: {
    1: [],
    2: [],
    3: [],
    4: [],
    5: [],
    6: [],
    7: [],
    8: [],
    9: [],
    10: [],
    11: [],
    12: [],
    13: [],
    14: [],
    15: [],
    16: [],
    17: [],
    18: [],
    19: [],
    20: [],
    21: [],
    22: [],
    23: [],
    24: [],
    25: [],
    26: [],
    27: [],
    28: [],
  },
  PT: {
    1: ['Vamos, vamos!', 'Será que...'],
    2: ['Vamos, vamos!', 'Será que...'],
    3: ['Vamos, vamos!', 'Será que...'],
    4: ['Vamos, vamos!', 'Será que...'],
    5: ['Vamos, vamos!', 'Será que...'],
    6: ['Vamos, vamos!', 'Será que...'],
    7: ['Vamos, vamos!', 'Será que...'],
    8: ['Vamos, vamos!', 'Será que...'],
    9: [
      'Já cá canta!',
      'Qual o próximo voo para as Maldivas?',
      'O VAR confirma: É um crack!',
      'O meu instinto nunca falha!',
    ],
    10: ['Já cá canta!', 'O VAR confirma: É um crack!', 'O meu instinto nunca falha!', 'Muitos anos a virar frangos!'],
    11: [
      'Já cá canta!',
      'O VAR confirma: É um crack!',
      'O meu instinto nunca falha!',
      'Muitos anos a virar frangos!',
      'À grande e à francesa!',
      'Qual o próximo voo para as Maldivas?',
    ],
    12: ['Já cá canta!', 'O VAR confirma: É um crack!', 'O meu instinto nunca falha!', 'Muitos anos a virar frangos!'],
    13: [
      'Já cá canta!',
      'O VAR confirma: É um crack!',
      'O meu instinto nunca falha!',
      'Muitos anos a virar frangos!',
      'À grande e à francesa!',
      'Qual o próximo voo para as Maldivas?',
    ],
    14: [
      'Já cá canta!',
      'O VAR confirma: É um crack!',
      'O meu instinto nunca falha!',
      'Muitos anos a virar frangos!',
      'À grande e à francesa!',
      'Qual o próximo voo para as Maldivas?',
    ],
    15: [
      'Já cá canta!',
      'O VAR confirma: É um crack!',
      'O meu instinto nunca falha!',
      'Muitos anos a virar frangos!',
      'À grande e à francesa!',
      'Qual o próximo voo para as Maldivas?',
    ],
    16: [
      'Já cá canta!',
      'O VAR confirma: É um crack!',
      'O meu instinto nunca falha!',
      'Muitos anos a virar frangos!',
      'À grande e à francesa!',
      'Qual o próximo voo para as Maldivas?',
    ],
    17: [
      'Já cá canta!',
      'O VAR confirma: É um crack!',
      'O meu instinto nunca falha!',
      'Muitos anos a virar frangos!',
      'À grande e à francesa!',
      'Qual o próximo voo para as Maldivas?',
    ],
    18: ['Esta não correu bem...'],
    19: ['Esta não correu bem...'],
    20: ['Esta não correu bem...'],
    21: ['Esta não correu bem...'],
    22: ['Esta não correu bem...'],
    23: ['Esta não correu bem...'],
    24: ['Esta não correu bem...'],
    25: [],
    26: [],
    27: [],
    28: [],
  },
};
